import React from "react";
import ReactDOM from "react-dom";
import ErrorBoundary from "../error-boundary/ErrorBoundary";

const LinkModule = props => {
  return (
    <div className={"link-module " + props.data.type}>
      <a href={props.data.pageURL}>
        <div className="col-12 col-sm-8 detail">
          <span className="category">
            {props.data.type == "howto" && (
              <span>
                <i className="fa fa-question-circle-o"></i>
                <span>How to</span>
              </span>
            )}
            {props.data.type == "external" && (
              <span>
                <i className="fa fa-chain"></i>
                <span>{props.data.type}</span>
              </span>
            )}

            {props.data.type == "download" &&
              props.data.fileType.toLowerCase().includes("word") && (
                <span>
                  <i className="fa fa-file-word-o"></i>
                  <span>
                    {props.data.type + " " + "(" + props.data.fileSize + ")"}
                  </span>
                </span>
              )}
            {props.data.type == "download" &&
              props.data.fileType.toLowerCase().includes("excel") && (
                <span>
                  <i className="fa fa-file-excel-o"></i>
                  <span>
                    {props.data.type + " " + "(" + props.data.fileSize + ")"}
                  </span>
                </span>
              )}
            {props.data.type == "download" &&
              props.data.fileType.toLowerCase().includes("pdf") && (
                <span>
                  <i className="fa fa-file-pdf-o"></i>
                  <span>
                    {props.data.type + " " + "(" + props.data.fileSize + ")"}
                  </span>
                </span>
              )}
            {props.data.type == "download" &&
              !props.data.fileType.toLowerCase().includes("word") &&
              !props.data.fileType.toLowerCase().includes("excel") &&
              !props.data.fileType.toLowerCase().includes("pdf") && (
                <span>
                  <i className="fa fa-file"></i>
                  <span>{props.data.type}</span>
                </span>
              )}
          </span>
          <span className="module-text">{props.data.pageName}</span>
          <p className="description">{props.data.description}</p>
        </div>
        <span
          className={
            props.data.type == "howto"
              ? "chevron"
              : props.data.type == "external"
              ? "external-icon"
              : props.data.type == "download"
              ? "download-icon"
              : ""
          }
        ></span>
      </a>
    </div>
  );
};

if (document.querySelectorAll(".link-module-react")[0]) {
  for (
    var i = 0;
    i < document.querySelectorAll(".link-module-react").length;
    i++
  ) {
    ReactDOM.render(
      <ErrorBoundary>
        <LinkModule data={linkModuleData[i]} />
      </ErrorBoundary>,

      document.querySelectorAll(".link-module-react")[i]
    );
  }
}

export default LinkModule;
